import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';
import { heroData } from '@/data/profile';
import IsometricIllustration from './IsometricIllustration';
import AnimatedSection from './AnimatedSection';

const Hero = () => {
  const scrollToContact = () => {
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="min-h-screen flex items-center justify-center relative overflow-hidden px-4 py-20">
      {/* Animated gradient orbs in background */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-gradient-to-br from-[#0066FF]/20 to-[#7B61FF]/20 rounded-full blur-3xl animate-pulse"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-br from-[#FF4D8D]/20 to-[#00D4FF]/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center relative z-10">
        {/* Left content */}
        <div className="space-y-8">
          <AnimatedSection animation="fade-up" delay={0}>
            <div className="space-y-4">
              <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight">
                {heroData.tagline}
              </h1>
              <p className="text-xl md:text-2xl text-[#a0a0a0]">
                Développeur <span className="bg-gradient-to-r from-[#0066FF] to-[#7B61FF] text-transparent bg-clip-text font-semibold">Symfony</span> basé à {heroData.location}
              </p>
            </div>
          </AnimatedSection>
          
          <AnimatedSection animation="fade-up" delay={200}>
            <Button 
              onClick={scrollToContact}
              className="bg-gradient-to-r from-[#0066FF] to-[#7B61FF] hover:from-[#0052CC] hover:to-[#6347CC] text-white px-8 py-6 text-lg rounded-xl shadow-lg hover:shadow-[#0066FF]/50 transition-all duration-300 hover:scale-105 group"
            >
              {heroData.cta}
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
          </AnimatedSection>
          
          <AnimatedSection animation="fade-in" delay={400}>
            <div className="flex gap-6 text-sm text-[#a0a0a0]">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-gradient-to-r from-[#00D4FF] to-[#0066FF] rounded-full animate-pulse"></div>
                <span>Disponible</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-gradient-to-r from-[#7B61FF] to-[#FF4D8D] rounded-full"></div>
                <span>100% Remote</span>
              </div>
            </div>
          </AnimatedSection>
        </div>
        
        {/* Right illustration */}
        <AnimatedSection animation="scale" delay={300} className="flex justify-center lg:justify-end">
          <IsometricIllustration />
        </AnimatedSection>
      </div>
    </section>
  );
};

export default Hero;